import { useEffect, useState } from 'react';

/**
 * Returns `value` only after it has stopped changing for `delayMs`.
 *
 * Use it to keep an input responsive (bind the input to the raw state) while
 * driving expensive work - a backend query, say - off the debounced copy, so a
 * fast typist produces one request instead of one per keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 400): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    // Each new value cancels the pending timer, so only a pause in typing
    // (longer than delayMs) lets a value through.
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}

export default useDebouncedValue;
